import React from 'react';

const TableOverlay = ({ loading = false, error = null, onRetry = null, children }) => {
    const className = `dashboard-section-overlay${loading ? ' dashboard-section-overlay--loading' : ''}`;

    return (
        <div className={className}>
            {children}
            {error && (
                <div className="dashboard-section-error">
                    <span className="dashboard-section-error__message">{error}</span>
                    {onRetry && (
                        <button className="dashboard-section-error__retry" onClick={onRetry}>
                            {__('Retry')}
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default TableOverlay;
